import { Data, HistoryNode } from '../../features/history/common/interface'

export const filterNodes = <T extends Data>(
  nodes: HistoryNode<T>[],
  filterText: string,
): HistoryNode<T>[] => {
  if (nodes) {
    return nodes
      .map(node => ({ ...node })) // Copy, um Originaldaten nicht zu modifizieren
      .filter(node => {
        // Prüfe, ob der Knoten oder seine Kinder übereinstimmen
        const matches =
          node.data?.id!.toLowerCase().includes(filterText.toLowerCase()) ||
          node.data?.createdBy!.toLowerCase().includes(filterText.toLowerCase())
        // Rekursiv Kinder filtern
        if (node.children && !matches) {
          const filteredChildren = filterNodes(node.children, filterText)
          node.children =
            filteredChildren.length > 0 ? filteredChildren : undefined
        }
        return matches || (node.children && node.children.length > 0)
      })
  }
  return []
}
